import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { getCurrentUser } from "../../Services/authService";
import GenerateInvoice from "./GenerateInvoice";
import { getAlert } from "../../Services/appAlerts";
import {
  useLoadCandidateAppsQuery,
  useLoadAppRuningTasksQuery,
  useUploadAppDocumentsMutation,
} from "../../app/store/candidateApiSlice";
import { useUpdateTimeLogInvoiceMutation } from "../../app/store/timeLogApiSlice";
import { useGetUserProfileLogoQuery } from "../../app/store/authApiSlice";
import { uploadFileToBlob } from "../../Services/blobUploadService";

const UPLOAD_INVOICE_STYLES = {
  modalContent: {
    borderRadius: "24px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalDialog: {
    maxWidth: "1120px"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "21px",
    boxShadow: "none"
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0
  },
  sectionCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px"
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "6px"
  },
  sectionSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginBottom: "14px",
    lineHeight: 1.6
  },
  optionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  optionCard: {
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    padding: "14px",
    minHeight: "96px",
    cursor: "pointer"
  },
  optionCardActive: {
    borderColor: "rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.08)"
  },
  optionTitle: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "4px"
  },
  optionHint: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.5,
    margin: 0
  },
  fieldLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "8px"
  },
  inputShell: {
    borderRadius: "14px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.03)"
  },
  errorText: {
    color: "#dc2626",
    fontSize: "12px",
    fontWeight: 600,
    marginTop: "6px",
    display: "block"
  },
  uploadBox: {
    borderRadius: "16px",
    border: "1px dashed rgba(148, 163, 184, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    padding: "16px"
  },
  logoRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    flexWrap: "wrap"
  },
  cameraButton: {
    width: "42px",
    height: "42px",
    borderRadius: "10px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    margin: 0,
    transition: "all 0.2s ease"
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap"
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  }
};

const UploadInvoice = (props) => {

  const { invShowHide, handleInvShowHide, candidateObj,
    selectedObj, timeLogInvoices, allRates, entType } = props;

  const [invOption, setInvOption] = useState(null);
  const [btnProess, setBtnProess] = useState(false);
  const [genShowHide, setGenShowHide] = useState(false);
  const [invNumber, setInvNumber] = useState("");
  const [notes, setNotes] = useState("");
  const [documents, setDocuments] = useState([]);
  const [saveInvDocs, setSaveInvDocs] = useState(false);
  const [error, setError] = useState("");

  const [logoPicObj, setLogoPicObj] = useState(null);

  const usrType = useMemo(() => localStorage.getItem("userType"), []);
  const currentUser = useMemo(() => getCurrentUser(), []);
  const usrId = currentUser?.linkUser || currentUser?.id;
  const currentUserId = currentUser?.id;

  // RTK Query hooks
  const { data: candidateApps = [] } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });

  const wfId = useMemo(() => {
    if (!candidateApps || candidateApps.length === 0) return 0;
    const mainWorkflow = candidateApps.filter(x => x.workflowType === 1);
    return mainWorkflow[0]?.oldWorkflowId || 0;
  }, [candidateApps]);

  const { data: appTasks = [] } = useLoadAppRuningTasksQuery(
    { wfId, userId: usrId },
    { skip: !wfId || !usrId }
  );

  const { data: logoData = null } = useGetUserProfileLogoQuery(usrId, { skip: !usrId });

  const [uploadAppDocuments, { data: uploadData }] = useUploadAppDocumentsMutation();
  const [updateTimeLogInvoice, { isSuccess: isUpdateSuccess }] = useUpdateTimeLogInvoiceMutation();

  const wfTask = useMemo(() => {
    if (!appTasks || appTasks.length === 0) return null;
    const filterTasks = appTasks.filter(x => x.taskType === 1 && x.wiid > 0);
    if (filterTasks.length > 0) {
      const reviewTasks = filterTasks.filter(x => x.registrationType === "WP");
      if (reviewTasks.length > 0) {
        return reviewTasks[reviewTasks.length - 1];
      }
      return filterTasks[0];
    }
    return null;
  }, [appTasks]);

  useEffect(() => {
    if (!invShowHide) {
      setInvNumber("");
      setNotes("");
      setInvOption(null);
    }
  }, [invShowHide]);

  const doSubmit = useCallback(() => {
    if (!invNumber.trim()) {
      setError("Invoice Number is required.");
    } else {
      setError("");
      setBtnProess(true);
      if (documents.length > 0) {
        const frmData = new FormData();
        frmData.append("message", notes);
        frmData.append("workflowTask", JSON.stringify(wfTask));
        frmData.append("userId", currentUserId);
        frmData.append("docType", "Invoice");
        frmData.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));
        uploadAppDocuments(frmData);
        setSaveInvDocs(true);
      }
    }
  }, [invNumber, documents, notes, wfTask, currentUserId, uploadAppDocuments]);

  useEffect(() => {
    const uploadId = uploadData?.uploadId ?? uploadData;
    if (uploadId > 0 && saveInvDocs) {
      setSaveInvDocs(false);
      const tmObj = {
        id: selectedObj?.id,
        invoiceDocId: uploadId,
        notes: notes,
        remarks: invNumber,
        docUploadType: usrType,
      };
      updateTimeLogInvoice(tmObj);
    } else if (uploadData !== undefined && saveInvDocs && !uploadId) {
      setSaveInvDocs(false);
      setBtnProess(false);
      getAlert("", "Invoice not found", "error");
    }
  }, [uploadData, saveInvDocs, selectedObj?.id, notes, invNumber, usrType, updateTimeLogInvoice]);

  useEffect(() => {
    const sasUrls = uploadData?.sasUrls;
    if (sasUrls && sasUrls.length > 0) {
      const uploadAllDocuments = async () => {
        try {
          await Promise.all(
            documents.map((file, key) =>
              uploadFileToBlob(
                file.file,
                sasUrls[key]?.uploadUrl,
                (progress) => {
                  console.log(`Upload progress: ${progress}%`);
                }
              )
            )
          );
          console.log("All files uploaded successfully!");
        } catch (error) {
          console.error("Upload failed:", error);
        }
      };
      uploadAllDocuments();
    }
  }, [uploadData, documents]);

  useEffect(() => {
    if (isUpdateSuccess) {
      setBtnProess(false);
      getAlert("Sent Successfully", "", "success");
      handleInvShowHide("save");
    }
  }, [isUpdateSuccess, handleInvShowHide]);

  const onFileChange = useCallback((event) => {
    const docs = [];
    for (let file of event.target.files) {
      const doc = {
        name: file.name,
        type: file.type,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  }, []);

  const handleInvChange = useCallback((value) => {
    setInvNumber(value);
  }, []);

  useEffect(() => {
    if (!invNumber.trim()) {
      setError("Invoice Number is required.");
    } else {
      setError("");
    }
  }, [invNumber]);

  const handleGenShowHide = useCallback((type) => {
    if (!invNumber.trim()) {
      setError("Invoice Number is required.");
    } else {
      setError("");
      setGenShowHide(prev => !prev);
      if (type === "save") {
        handleInvShowHide("save");
      }
    }
  }, [invNumber, handleInvShowHide]);

  const handleImageChange = useCallback((e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setLogoPicObj({
        file: file,
        fileName: file.name,
        imagePreviewUrl: reader.result,
      });
    };
    reader.readAsDataURL(file);
  }, []);

  let $imagePreview = null;
  if (logoPicObj) {
    $imagePreview = <img src={logoPicObj.imagePreviewUrl}
      alt="profile" className="img-thumbnail profilePrev" />
  } else {
    $imagePreview = <img
      alt="profile" className="img-thumbnail profilePrev2"
      src={`${!logoData ? "../../assets/img/theme/logo.png" : process.env.REACT_APP_API_BASEURL + "/CompanyLogo/" + logoData}`}
    />
  }

  return (
    <React.Fragment>
      <Modal
        show={invShowHide}
        size="lg"
        centered
        onHide={() => handleInvShowHide("")}
        dialogClassName="upload-invoice-modal-dialog"
        contentClassName="upload-invoice-modal-content"
      >
        <style>{`
          .upload-invoice-modal-dialog {
            max-width: ${UPLOAD_INVOICE_STYLES.modalDialog.maxWidth};
          }
          .upload-invoice-modal-content {
            border-radius: ${UPLOAD_INVOICE_STYLES.modalContent.borderRadius};
            overflow: ${UPLOAD_INVOICE_STYLES.modalContent.overflow};
            border: ${UPLOAD_INVOICE_STYLES.modalContent.border};
            box-shadow: ${UPLOAD_INVOICE_STYLES.modalContent.boxShadow};
          }
        `}</style>
        <Modal.Header style={UPLOAD_INVOICE_STYLES.modalHeader}>
          <div style={UPLOAD_INVOICE_STYLES.headerContent}>
            <Modal.Title as="div" style={UPLOAD_INVOICE_STYLES.titleWrap}>
              <span style={UPLOAD_INVOICE_STYLES.headerIcon}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i>
              </span>
              <div>
                <h2 style={UPLOAD_INVOICE_STYLES.title}>Upload Invoice</h2>
                <div style={UPLOAD_INVOICE_STYLES.subtitle}>
                  Upload a prepared invoice or generate one from the selected time log.
                </div>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={UPLOAD_INVOICE_STYLES.closeButton}
              onClick={() => handleInvShowHide("")}
              aria-label="Close upload invoice popup"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body style={UPLOAD_INVOICE_STYLES.modalBody}>
          <div style={UPLOAD_INVOICE_STYLES.helperCard}>
            <div style={UPLOAD_INVOICE_STYLES.helperTitle}>Choose how to submit this invoice</div>
            <p style={UPLOAD_INVOICE_STYLES.helperText}>
              Use manual upload when you already have an invoice file. Use automatic generation when this invoice should be created from the selected time log details.
            </p>
          </div>
          <div style={UPLOAD_INVOICE_STYLES.sectionCard}>
            <div style={UPLOAD_INVOICE_STYLES.sectionTitle}>Invoice Option</div>
            <div style={UPLOAD_INVOICE_STYLES.sectionSubtitle}>
              Select one option before entering invoice details.
            </div>
            <div style={UPLOAD_INVOICE_STYLES.optionGrid}>
              <label
                htmlFor="manual"
                style={{
                  ...UPLOAD_INVOICE_STYLES.optionCard,
                  ...(invOption === "manual" ? UPLOAD_INVOICE_STYLES.optionCardActive : {})
                }}
              >
                <div className="custom-control custom-radio">
                  <input
                    name="invOption"
                    className="custom-control-input"
                    id="manual"
                    type="radio"
                    value="manual"
                    checked={invOption === "manual"}
                    onChange={() => setInvOption("manual")}
                  />
                  <span className="custom-control-label">
                    <span style={UPLOAD_INVOICE_STYLES.optionTitle}>Manual Upload Invoice</span>
                  </span>
                </div>
                <p style={UPLOAD_INVOICE_STYLES.optionHint}>
                  Attach an existing invoice document and send it for review.
                </p>
              </label>
              <label
                htmlFor="automatic"
                style={{
                  ...UPLOAD_INVOICE_STYLES.optionCard,
                  ...(invOption === "automatic" ? UPLOAD_INVOICE_STYLES.optionCardActive : {})
                }}
              >
                <div className="custom-control custom-radio">
                  <input
                    name="invOption"
                    className="custom-control-input"
                    id="automatic"
                    value="automatic"
                    type="radio"
                    checked={invOption === "automatic"}
                    onChange={() => setInvOption("automatic")}
                  />
                  <span className="custom-control-label">
                    <span style={UPLOAD_INVOICE_STYLES.optionTitle}>Generate Automatic Invoice</span>
                  </span>
                </div>
                <p style={UPLOAD_INVOICE_STYLES.optionHint}>
                  Create an invoice using the current time log and company branding.
                </p>
              </label>
            </div>

            {invOption && <>
              <div className="row">
                <div className="col-md-6 form-group">
                  <label htmlFor="invNumber" style={UPLOAD_INVOICE_STYLES.fieldLabel}>Invoice Number <span style={{ color: "#dc2626" }}>*</span></label>
                  <input type="text"
                    className="form-control"
                    style={UPLOAD_INVOICE_STYLES.inputShell}
                    value={invNumber}
                    id="invNumber"
                    name="invNumber"
                    placeholder="Invoice Number"
                    onChange={({ currentTarget }) => handleInvChange(currentTarget.value)}
                  />
                  {error && <small style={UPLOAD_INVOICE_STYLES.errorText}>{error}</small>}
                </div>
                <div className="col-md-6 form-group">
                  <label htmlFor="notes" style={UPLOAD_INVOICE_STYLES.fieldLabel}>Notes</label>
                  <textarea cols={2} rows={2}
                    name="notes"
                    id="notes"
                    value={notes}
                    className="form-control"
                    style={UPLOAD_INVOICE_STYLES.inputShell}
                    placeholder="Notes"
                    onChange={({ currentTarget }) => setNotes(currentTarget.value)}
                  ></textarea>
                </div>
              </div>
            </>}

            {invOption === "manual" && (
              <React.Fragment>
                <div style={UPLOAD_INVOICE_STYLES.uploadBox}>
                  <label htmlFor="invfile" style={UPLOAD_INVOICE_STYLES.fieldLabel}>Upload Invoice File</label>
                  <input type="file"
                    name="invfile"
                    id="invfile"
                    className="form-control"
                    style={UPLOAD_INVOICE_STYLES.inputShell}
                    onChange={onFileChange}
                  />
                </div>
              </React.Fragment>
            )}



            {invOption === "automatic" && (
              <React.Fragment>
                <div style={UPLOAD_INVOICE_STYLES.uploadBox}>
                  <label style={UPLOAD_INVOICE_STYLES.fieldLabel}>Upload Company Logo</label>
                  <div style={UPLOAD_INVOICE_STYLES.logoRow}>
                    {$imagePreview}
                    <div>
                      <label className="profileBtn" style={UPLOAD_INVOICE_STYLES.cameraButton} title="Upload company logo">
                        <input
                          type="file"
                          onChange={handleImageChange}
                          style={{ display: "none" }}
                        />
                        <i className="fa fa-camera" aria-hidden="true"></i>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <button
                    className="btn btn-sm"
                    style={UPLOAD_INVOICE_STYLES.primaryButton}
                    onClick={handleGenShowHide}
                  >
                    <i className="fa fa-cog"></i> Generate
                  </button>
                </div>

              </React.Fragment>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer style={UPLOAD_INVOICE_STYLES.modalFooter}>
          <div style={UPLOAD_INVOICE_STYLES.footerActions}>
            <button
              className="btn btn-sm"
              style={UPLOAD_INVOICE_STYLES.subtleButton}
              onClick={() => handleInvShowHide("")}
            >
              <i className="fa fa-times" aria-hidden="true"></i> Close
            </button>
            {invOption === "manual" && documents.length > 0 &&
              <button className="btn btn-sm"
                style={UPLOAD_INVOICE_STYLES.primaryButton}
                disabled={btnProess}
                onClick={doSubmit}
              >
                {btnProess ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-paper-plane"></i>}
                Send
              </button>}
          </div>
        </Modal.Footer>
      </Modal>

      {genShowHide && <GenerateInvoice
        genShowHide={genShowHide}
        handleGenShowHide={handleGenShowHide}
        selectedObj={selectedObj}
        candidateObj={candidateObj}
        invoiceNumber={invNumber}
        notes={notes}
        wfTask={wfTask}
        timeLogInvoices={timeLogInvoices}
        invNumber={invNumber}
        logoPicObj={logoPicObj}
        logoData={logoData}
        allRates={allRates}
        entType={entType}
      ></GenerateInvoice>}
    </React.Fragment>
  );
}

export default UploadInvoice;
